import { useEffect, useState } from "react";
import { api } from "@/api";
import logoUrl from "@/assets/ankhara-logo-mark.png";

// Stable shareable URL for the current community upload link — safe to print,
// QR-code, and drop in email blasts. Resolves whatever link is active right now.
export default function FloorUploadRedirect() {
  const [dead, setDead] = useState(false);
  useEffect(() => {
    api.get("/community/upload-link")
      .then(({ data }) => {
        if (data.url) {
          window.location.replace(data.url);
        } else {
          setDead(true);
        }
      })
      .catch(() => setDead(true));
  }, []);

  return (
    <div className="upl-page" data-testid="floor-redirect">
      <header className="upl-head">
        <a href="/" data-testid="floor-home-link"><img src={logoUrl} alt="ANKHARA" className="com-logo" /></a>
      </header>
      <main className="upl-main upl-center">
        {dead ? (
          <>
            <h1 className="upl-title" data-testid="floor-closed">THE FLOOR IS CLOSED</h1>
            <p className="upl-sub">No community drop is open right now. Watch our stories when the next session lands.</p>
          </>
        ) : (
          <p className="com-loader" data-testid="floor-loading">OPENING THE FLOOR…</p>
        )}
      </main>
    </div>
  );
}
